import { restClient } from '@/Core'

import { APPLICATION_REST_URL } from '../Contracts/IApplication'

/** Одна невиконана вимога: поле картки й текст бека (`SPEC-021` §5.3). */
export interface ApplicationRequirement {
    propertyPath: string | null
    message: string
}

/** Відповідь `GET /services/applications/{uuid}/status_requirements?status=<код>`. */
export interface ApplicationRequirementsResponse {
    status: string
    satisfied: boolean
    violations: ApplicationRequirement[]
}

/**
 * «Чого бракує до статусу» (`SPEC-021` §5.3, ДЗ-08): бек звіряє заявку з
 * правилами резолвера й нічого не зберігає. `forceRefresh` — ядровий клієнт
 * кешує GET, а після правки картки відповідь мусить бути свіжою.
 */
export const LoadStatusRequirementsTask = async (uuid: string, code: string): Promise<ApplicationRequirementsResponse> => {
    const raw = (await restClient.get(
        `${APPLICATION_REST_URL}/${encodeURIComponent(uuid)}/status_requirements?status=${encodeURIComponent(code)}`,
        undefined,
        { forceRefresh: true }
    )) as unknown as Partial<ApplicationRequirementsResponse> | null

    const violations = (Array.isArray(raw?.violations) ? raw.violations : []).filter(
        (item): item is ApplicationRequirement => typeof item?.message === 'string'
    )

    return { status: String(raw?.status ?? code), satisfied: raw?.satisfied === true, violations }
}
